import { useState } from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { fibeTokens } from '../../theme';
import './FibeCommissionBilling.css';
import OverviewTab from './tabs/OverviewTab';
import ReconciliationTab from './tabs/ReconciliationTab';
import CommissionsTab from './tabs/CommissionsTab';
import InvoicesTab from './tabs/InvoicesTab';
import DpdTab from './tabs/DpdTab';
import SubAgentsTab from './tabs/SubAgentsTab';
import SettingsTab from './tabs/SettingsTab';

const TABS = [
    { key: 'overview', label: 'Overview', Component: OverviewTab },
    { key: 'reconciliation', label: 'Reconciliation', Component: ReconciliationTab },
    { key: 'commissions', label: 'Commissions', Component: CommissionsTab },
    { key: 'invoices', label: 'Invoices', Component: InvoicesTab },
    { key: 'dpd', label: 'DPD Upload', Component: DpdTab },
    { key: 'subagents', label: 'Sub-Agents', Component: SubAgentsTab },
    { key: 'settings', label: 'Settings', Component: SettingsTab },
];

const { color } = fibeTokens;

function FibeCommissionBilling() {
    const [activeTabKey, setActiveTabKey] = useState(TABS[0].key);
    const ActiveTabComponent = TABS.find((tab) => tab.key === activeTabKey).Component;

    return (
        <Box className="fibe-billing" sx={{ background: color.surface, minHeight: '100%' }}>
            <Tabs
                value={activeTabKey}
                onChange={(event, newValue) => setActiveTabKey(newValue)}
                TabIndicatorProps={{ style: { backgroundColor: color.primary, height: fibeTokens.tabs.indicatorHeight, borderRadius: '3px 3px 0 0' } }}
                sx={{
                    ...fibeTokens.tabs.containerSx,
                    '& .MuiTab-root': { fontFamily: fibeTokens.font.family, ...fibeTokens.tabs.tabSx },
                }}
            >
                {TABS.map((tab) => (
                    <Tab key={tab.key} value={tab.key} label={tab.label} disableRipple />
                ))}
            </Tabs>
            <div className="container">
                <ActiveTabComponent onNavigateToTab={setActiveTabKey} />
            </div>
        </Box>
    );
}

export default FibeCommissionBilling;
